const style = (theme) => {
  const output = {
    root: {
      position: 'relative',
      width: '100vw',
      height: 'calc(var(--vh) * 100)',
      fallbacks: {
        height: '100%',
      },
      overflow: 'hidden',
      '& .TextSlide__title': {
        fontFamily: theme.fonts[2],
        fontSize: 'calc(45px + 2vw)',
        lineHeight: 1.2,
      },
    },
    media: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      fontFamily: "'object-fit: cover;'",
      objectPosition: 'center',
    },
    mediaContainer: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      opacity: 0,
      transform: 'scale(1.08)',
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        background: theme.getRgba(theme.colors[2], 0.4),
      },
    },
    filter: {
      display: 'none',
    },
    content: {
      position: 'relative',
      width: '100%',
      height: '100%',
      display: 'flex',
      padding: '120px 7vw 120px 7vw',
      '& p': {
        margin: 0,
      },
    },
    scrollIndicator: {
      padding: '0 5vw',
      position: 'absolute',
      bottom: 0,
      left: 0,
    },
    layoutCenter: {
      '& $content': {
        alignItems: 'center',
      },
    },
    layoutBottom: {
      '& $content': {
        alignItems: 'flex-end',
      },
    },
    bigFont: {
      '& .TextSlide__title': {
        fontSize: '10vw',
        textTransform: 'uppercase',
        fontFamily: theme.fonts[1],
        lineHeight: 1,
        letterSpacing: '2px',
        paddingRight: '5vw',
      },
    },
    plainFont: {
      '& .TextSlide__title': {
        fontSize: 48,
        textTransform: 'uppercase',
        fontFamily: theme.fonts[0],
        fontWeight: 300,
        lineHeight: 1,
        paddingRight: '5vw',
      },
    },
    backgroundLight: {
      background: theme.colors[1],
    },
  }

  output[theme.mediaInverse.sm] = {
    root: {
      '& .TextSlide__title': {
        fontSize: 'calc(25px + 3vw)',
      },
    },
    plainFont: {
      '& .TextSlide__title': {
        fontSize: 30,
      },
    },
    content: {
      padding: '60px 7vw 60px 7vw',
    },
  }

  return output
}

export default style
